import styled from '@emotion/styled';
import { PartialSlidingSideMenuProps } from './types';
import { css } from '../customEmotion';
import { theme } from '../styles/theme';

const defaultOffset = 200;

const duration = (props: PartialSlidingSideMenuProps) => {
  let duration = 0.2;

  if (props.duration && typeof props.duration === 'number') {
    duration = props.duration / 1000;
  }

  return `${duration}s`;
};

const translateOffset = (props: PartialSlidingSideMenuProps) => {
  const { open, position } = props;
  const offset = width(props);

  if (position === 'left') {
    if (open) {
      return '0';
    } else {
      return `-${offset}px`;
    }
  } else {
    if (open) {
      return '0';
    } else {
      return `${offset}px`;
    }
  }
};

const position = (props: PartialSlidingSideMenuProps) => {
  const { position } = props;

  if (position === 'left') {
    return 'left: 0';
  } else {
    return 'right: 0';
  }
};

const width = (props: PartialSlidingSideMenuProps) => {
  const { width } = props;

  if (typeof width === 'number' && width > defaultOffset) {
    return width;
  } else {
    return defaultOffset;
  }
};

export const StyledSideMenu = styled.section<PartialSlidingSideMenuProps>`
  background-color: white;
  transition: transform ${duration};
  transform: translateX(${translateOffset});
  position: fixed;
  ${position};
  bottom: 0;
  top: 0;
  min-width: ${width}px;
  height: 100%;
  z-index: ${theme.zIndex.appBar};
`;

export const StyledIconWrapper = styled.div`
  padding: 8px;
  display: inline-block;
  cursor: pointer;
`;

export const IconStyle = css`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.color.primary.default};
`;
